/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { content } from "../../../data";

function HeroSectionCarousel() {

  const [currentSlide, setCurrentSlide] = useState(0);
  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const renderDots = () => {
    return content?.HomeCarouselSlider.map((_, index) => (
      <span
        key={index}
        className={`w-2.5 h-2.5 rounded-full inline-block mx-[5px] cursor-pointer ${
          index === currentSlide
            ? "bg-bright-yellow w-8 transition-all duration-500"
            : "border border-bright-yellow"
        }`}
        onClick={() => handleDotClick(index)}
      />
    ));
  };


  const settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: determineSlidesToShow(),
    slidesToScroll: 1,
    centerMode: false,
    pauseOnHover: true,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  function determineSlidesToShow() {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) {
      return 3;
    } else if (screenWidth >= 600 && screenWidth < 1024) {
      return 2;
    } else {
      return 1;
    }
  }

  useEffect(() => {
    const handleResize = () => {
      const newSlidesToShow = determineSlidesToShow();
      settings.slidesToShow = newSlidesToShow;
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [currentSlide]);

  return (
    <>
      <div className="slider-container w-full lg:w-[125%] xl:w-[80%]">
        <Slider {...settings} className="slick-track">
          {content?.HomeCarouselSlider.map((image, index) => 
          (
            
            <div key={index} className="!flex !justify-center lg:!block px-2 ">
              <img
                className={`yellow-border w-[286px] h-[342px] object-cover ${
                  currentSlide === index ? "" : "opacity-40"
                }`}
                src={image.icon}
                alt={`Golden NFT ${index + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </Slider>
      </div>
      <div className="dots-container flex justify-center my-5 lg:relative lg:left-[-16%]">
        {renderDots()}
      </div>
    </>
  );
}

export default HeroSectionCarousel;
